// Generated by purs version 0.15.15
import * as Control_Alternative from "../Control.Alternative/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State from "../Control.Monad.State/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as ProtoVoices_Leftmost from "../ProtoVoices.Leftmost/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
var map = /* #__PURE__ */ Data_Functor.map(ProtoVoices_Model.functorStartStop);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var bindStateT = /* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Either.monadEither);
var discard1 = /* #__PURE__ */ discard(bindStateT);
var monadStateStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Either.monadEither);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(monadStateStateT);
var max = /* #__PURE__ */ Data_Ord.max(ProtoVoices_Model.ordTransId);
var bind = /* #__PURE__ */ Control_Bind.bind(bindStateT);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT)(Data_Either.monadEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Either.monadEither));
var max1 = /* #__PURE__ */ Data_Ord.max(ProtoVoices_Model.ordSliceId);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var pitchIsSymbol = {
    reflectSymbol: function () {
        return "pitch";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var eqStartStop = /* #__PURE__ */ ProtoVoices_Model.eqStartStop(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(pitchIsSymbol)(/* #__PURE__ */ Data_Pitches_Class.eqPitch(Data_Pitches_Spelled.eqSInterval)))()(idIsSymbol)(Data_Eq.eqString)));
var eq = /* #__PURE__ */ Data_Eq.eq(eqStartStop);
var modify = /* #__PURE__ */ Control_Monad_State_Class.modify(monadStateStateT);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord();
var ordRecordCons = /* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)();
var rightIsSymbol = {
    reflectSymbol: function () {
        return "right";
    }
};
var ordRecord1 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons(pitchIsSymbol)(/* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval)))()(idIsSymbol)(Data_Ord.ordString));
var ordStartStop = /* #__PURE__ */ ProtoVoices_Model.ordStartStop(ordRecord1);
var leftIsSymbol = {
    reflectSymbol: function () {
        return "left";
    }
};
var ordRecord2 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons(rightIsSymbol)(ordStartStop))()(leftIsSymbol)(ordStartStop));
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRecord2);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var map2 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_State_Trans.functorStateT(Data_Either.functorEither));
var fromFoldable1 = /* #__PURE__ */ Data_List.fromFoldable(Data_Foldable.foldableArray);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity));
var bindStateT1 = /* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity);
var bind3 = /* #__PURE__ */ Control_Bind.bind(bindStateT1);
var discard2 = /* #__PURE__ */ discard(bindStateT1);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_List_Types.semigroupList);
var monadStateStateT1 = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity);
var modify_1 = /* #__PURE__ */ Control_Monad_State_Class.modify_(monadStateStateT1);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Either.bindEither);
var fromFoldable2 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var eq1 = /* #__PURE__ */ Data_Eq.eq(ProtoVoices_Model.eqNoteExplanation);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var fromFoldableWith = /* #__PURE__ */ Data_Map_Internal.fromFoldableWith(ordRecord1);
var fromFoldableWith1 = /* #__PURE__ */ fromFoldableWith(Data_Foldable.foldableArray);
var append2 = /* #__PURE__ */ Data_Semigroup.append(ProtoVoices_Leftmost.semigroupHoriChildren);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(ProtoVoices_Model.eqDoubleOrnament));
var bind4 = /* #__PURE__ */ Control_Bind.bind(Control_Bind.bindArray);
var fromFoldable3 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var discard3 = /* #__PURE__ */ discard(Control_Bind.bindArray);
var guard = /* #__PURE__ */ Control_Alternative.guard(Control_Alternative.alternativeArray);
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var fromFoldableWith2 = /* #__PURE__ */ Data_Map_Internal.fromFoldableWith(ordRecord2)(Data_List_Types.foldableList);
var fromFoldableWith3 = /* #__PURE__ */ fromFoldableWith(Data_List_Types.foldableList);
var difference = /* #__PURE__ */ Data_Array.difference(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(rightIsSymbol)(eqStartStop))()(leftIsSymbol)(eqStartStop)));
var passingIsSymbol = {
    reflectSymbol: function () {
        return "passing";
    }
};
var regularIsSymbol = {
    reflectSymbol: function () {
        return "regular";
    }
};
var append3 = /* #__PURE__ */ Data_Semigroup.append(/* #__PURE__ */ Data_Semigroup.semigroupRecord()(/* #__PURE__ */ Data_Semigroup.semigroupRecordCons(passingIsSymbol)()(/* #__PURE__ */ Data_Semigroup.semigroupRecordCons(regularIsSymbol)()(Data_Semigroup.semigroupRecordNil)(/* #__PURE__ */ Data_Set.semigroupSet(ordRecord2)))(Data_Semigroup.semigroupArray)));
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(/* #__PURE__ */ Data_Monoid.monoidRecord()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(passingIsSymbol)(Data_Monoid.monoidArray)()(/* #__PURE__ */ Data_Monoid.monoidRecordCons(regularIsSymbol)(/* #__PURE__ */ Data_Set.monoidSet(ordRecord2))()(Data_Monoid.monoidRecordNil))));
var insert = /* #__PURE__ */ Data_Map_Internal.insert(ProtoVoices_Model.ordTransId);
var max2 = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordNumber);
var insert1 = /* #__PURE__ */ Data_Map_Internal.insert(ProtoVoices_Model.ordSliceId);
var gets = /* #__PURE__ */ Control_Monad_State_Class.gets(monadStateStateT1);
var ET = /* #__PURE__ */ (function () {
    function ET(value0) {
        this.value0 = value0;
    };
    ET.create = function (value0) {
        return new ET(value0);
    };
    return ET;
})();
var EN = /* #__PURE__ */ (function () {
    function EN(value0) {
        this.value0 = value0;
    };
    EN.create = function (value0) {
        return new EN(value0);
    };
    return EN;
})();
var ER = /* #__PURE__ */ (function () {
    function ER(value0) {
        this.value0 = value0;
    };
    ER.create = function (value0) {
        return new ER(value0);
    };
    return ER;
})();
var EL = /* #__PURE__ */ (function () {
    function EL(value0) {
        this.value0 = value0;
    };
    EL.create = function (value0) {
        return new EL(value0);
    };
    return EL;
})();
var partitionElaborations = function (dictFoldable) {
    var select = function (v) {
        return function (v1) {
            if (v1 instanceof ET) {
                return {
                    t: new Data_List_Types.Cons(v1.value0, v.t),
                    n: v.n,
                    r: v.r,
                    l: v.l
                };
            };
            if (v1 instanceof EN) {
                return {
                    t: v.t,
                    n: new Data_List_Types.Cons(v1.value0, v.n),
                    r: v.r,
                    l: v.l
                };
            };
            if (v1 instanceof ER) {
                return {
                    t: v.t,
                    n: v.n,
                    r: new Data_List_Types.Cons(v1.value0, v.r),
                    l: v.l
                };
            };
            if (v1 instanceof EL) {
                return {
                    t: v.t,
                    n: v.n,
                    r: v.r,
                    l: new Data_List_Types.Cons(v1.value0, v.l)
                };
            };
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 254, column 27 - line 258, column 36): " + [ v1.constructor.name ]);
        };
    };
    return Data_Foldable.foldl(dictFoldable)(select)({
        t: Data_List_Types.Nil.value,
        n: Data_List_Types.Nil.value,
        r: Data_List_Types.Nil.value,
        l: Data_List_Types.Nil.value
    });
};
var partitionElaborations1 = /* #__PURE__ */ partitionElaborations(Data_Foldable.foldableArray);
var nothingMore = function (seg) {
    return {
        seg: seg,
        more: Data_Unit.unit
    };
};
var leftmostToReduction = function (topSegments) {
    return function (deriv) {
        var startSlice = {
            id: 0,
            x: 0.0,
            notes: ProtoVoices_Model.Start.value,
            parents: ProtoVoices_Model.NoParents.value
        };
        var prepareTop = function (v) {
            return {
                transId: v.trans.id,
                rslice: {
                    id: v.rslice.id,
                    parents: ProtoVoices_Model.NoParents.value,
                    notes: map(map1(function (note) {
                        return {
                            note: note,
                            expl: ProtoVoices_Model.NoExpl.value
                        };
                    }))(v.rslice.notes)
                }
            };
        };
        var prepareSplit = function (leftSliceId) {
            return function (top) {
                return function (v) {
                    return discard1(modify_(function (st) {
                        var $230 = {};
                        for (var $231 in st) {
                            if ({}.hasOwnProperty.call(st, $231)) {
                                $230[$231] = st[$231];
                            };
                        };
                        $230.maxT = max(st.maxT)(top.transId);
                        return $230;
                    }))(function () {
                        return bind(lift(ProtoVoices_Leftmost.splitGetChildNotes(v)))(function (childNotes) {
                            var childrTop = {
                                transId: v.ids.right,
                                rslice: top.rslice
                            };
                            var childSlice = {
                                id: v.ids.slice,
                                notes: new ProtoVoices_Model.Inner(childNotes),
                                parents: new ProtoVoices_Model.MergeParents({
                                    left: leftSliceId,
                                    right: top.rslice.id
                                })
                            };
                            var childlTop = {
                                transId: v.ids.left,
                                rslice: childSlice
                            };
                            return pure({
                                childlTop: childlTop,
                                childrTop: childrTop
                            });
                        });
                    });
                };
            };
        };
        var prepareHori = function (topl) {
            return function (topr) {
                return function (v) {
                    return discard1(modify_(function (st) {
                        var $236 = {};
                        for (var $237 in st) {
                            if ({}.hasOwnProperty.call(st, $237)) {
                                $236[$237] = st[$237];
                            };
                        };
                        $236.maxT = max(st.maxT)(max(topl.transId)(topr.transId));
                        $236.maxS = max1(st.maxS)(topl.rslice.id);
                        return $236;
                    }))(function () {
                        var childrTop = {
                            transId: v.ids.right,
                            rslice: topr.rslice
                        };
                        var childmTop = {
                            transId: v.ids.mid,
                            rslice: {
                                id: v.ids.rslice,
                                notes: new ProtoVoices_Model.Inner(ProtoVoices_Leftmost.horiRightChildren(v)),
                                parents: new ProtoVoices_Model.VertParent(topl.rslice.id)
                            }
                        };
                        var childlTop = {
                            transId: v.ids.left,
                            rslice: {
                                id: v.ids.lslice,
                                notes: new ProtoVoices_Model.Inner(ProtoVoices_Leftmost.horiLeftChildren(v)),
                                parents: new ProtoVoices_Model.VertParent(topl.rslice.id)
                            }
                        };
                        return pure({
                            childlTop: childlTop,
                            childmTop: childmTop,
                            childrTop: childrTop
                        });
                    });
                };
            };
        };
        var freeze = function (lslice) {
            return function (v) {
                return function (v1) {
                    var holdNote = function (v2) {
                        var hold = bind1(Data_Array.find(function (v3) {
                            return eq(v3.left)(new ProtoVoices_Model.Inner(v2.note));
                        })(v.ties))(function (edge) {
                            return bind1(ProtoVoices_Model.getInner(edge.right))(function (right) {
                                return new Data_Maybe.Just(right.id);
                            });
                        });
                        return {
                            note: v2.note,
                            hold: hold
                        };
                    };
                    var pieceNotes = map1(holdNote)(ProtoVoices_Model.sortNotes(ProtoVoices_Model.getInnerNotes(lslice)));
                    return bind(modify(function (st) {
                        var $246 = {};
                        for (var $247 in st) {
                            if ({}.hasOwnProperty.call(st, $247)) {
                                $246[$247] = st[$247];
                            };
                        };
                        $246.x = st.x + 1.0;
                        $246.maxT = max(st.maxT)(v1.transId);
                        $246.maxS = max1(st.maxS)(v1.rslice.id);
                        $246.piece = Data_Array.snoc(st.piece)({
                            notes: pieceNotes,
                            time: v.prevTime
                        });
                        return $246;
                    }))(function (st) {
                        return pure({
                            trans: {
                                id: v1.transId,
                                edges: {
                                    passing: [  ],
                                    regular: fromFoldable(v.ties)
                                },
                                is2nd: false
                            },
                            rslice: {
                                id: v1.rslice.id,
                                notes: v1.rslice.notes,
                                parents: v1.rslice.parents,
                                x: st.x
                            },
                            op: ProtoVoices_Model.Freeze.value
                        });
                    });
                };
            };
        };
        var completeSplit = function (top) {
            return function (childl) {
                return function (childr) {
                    return {
                        trans: {
                            id: top.transId,
                            edges: ProtoVoices_Model.parentEdges(childl.rslice),
                            is2nd: childl.trans.is2nd
                        },
                        rslice: childr.rslice,
                        op: new ProtoVoices_Model.Split({
                            childl: childl,
                            childr: ProtoVoices_Model.detachSegment(childr)
                        })
                    };
                };
            };
        };
        var completeHori = function (topl) {
            return function (topr) {
                return function (childl) {
                    return function (childm) {
                        return function (childr) {
                            var topSlice = {
                                id: topl.rslice.id,
                                notes: topl.rslice.notes,
                                parents: topl.rslice.parents,
                                x: (childl.rslice.x + childm.rslice.x) / 2.0
                            };
                            return bind2(ProtoVoices_Model.vertEdgesLeft(childl.trans.edges)(childl.rslice))(function (edgesL) {
                                return bind2(ProtoVoices_Model.vertEdgesRight(childr.trans.edges)(childm.rslice))(function (edgesR) {
                                    var segr = {
                                        trans: {
                                            id: topr.transId,
                                            edges: edgesR,
                                            is2nd: true
                                        },
                                        rslice: childr.rslice,
                                        op: ProtoVoices_Model.Freeze.value
                                    };
                                    var segl = {
                                        trans: {
                                            id: topl.transId,
                                            edges: edgesL,
                                            is2nd: false
                                        },
                                        rslice: topSlice,
                                        op: new ProtoVoices_Model.Hori({
                                            childl: childl,
                                            childm: childm,
                                            childr: ProtoVoices_Model.detachSegment(childr)
                                        })
                                    };
                                    return pure1({
                                        segl: segl,
                                        segr: segr
                                    });
                                });
                            });
                        };
                    };
                };
            };
        };
        var go = function (v) {
            return function (v1) {
                return function (v2) {
                    if (v1 instanceof Data_List_Types.Nil && v2 instanceof Data_List_Types.Nil) {
                        return pure(Data_List_Types.Nil.value);
                    };
                    if (v1 instanceof Data_List_Types.Cons && v2 instanceof Data_List_Types.Cons) {
                        if (v1.value1 instanceof Data_List_Types.Cons) {
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMFreezeLeft) {
                                return bind(freeze(v)(v2.value0.value0)(v1.value0))(function (top$prime) {
                                    return map2(Data_List_Types.Cons.create(top$prime))(go(top$prime.rslice)(v1.value1)(v2.value1));
                                });
                            };
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMSplitLeft) {
                                return bind(prepareSplit(v.id)(v1.value0)(v2.value0.value0))(function (v3) {
                                    return bind(go(v)(new Data_List_Types.Cons(v3.childlTop, new Data_List_Types.Cons(v3.childrTop, v1.value1)))(v2.value1))(function (segs) {
                                        if (segs instanceof Data_List_Types.Cons && segs.value1 instanceof Data_List_Types.Cons) {
                                            return pure(new Data_List_Types.Cons(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), segs.value1.value1));
                                        };
                                        return lift(new Data_Either.Left("Operations after splitLeft do not fit!"));
                                    });
                                });
                            };
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMSplitRight) {
                                return bind(prepareSplit(v1.value0.rslice.id)(v1.value1.value0)(v2.value0.value0))(function (v3) {
                                    return bind(go(v)(new Data_List_Types.Cons(v1.value0, new Data_List_Types.Cons(v3.childlTop, new Data_List_Types.Cons(v3.childrTop, v1.value1.value1))))(v2.value1))(function (segs) {
                                        if (segs instanceof Data_List_Types.Cons && (segs.value1 instanceof Data_List_Types.Cons && segs.value1.value1 instanceof Data_List_Types.Cons)) {
                                            return pure(new Data_List_Types.Cons(segs.value0, new Data_List_Types.Cons(completeSplit(v1.value1.value0)(segs.value1.value0)(segs.value1.value1.value0), segs.value1.value1.value1)));
                                        };
                                        return lift(new Data_Either.Left("Operations after splitRight do not fit!"));
                                    });
                                });
                            };
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMHorizontalize) {
                                return bind(prepareHori(v1.value0)(v1.value1.value0)(v2.value0.value0))(function (v3) {
                                    return bind(go(v)(new Data_List_Types.Cons(v3.childlTop, new Data_List_Types.Cons(v3.childmTop, new Data_List_Types.Cons(v3.childrTop, v1.value1.value1))))(v2.value1))(function (segs) {
                                        if (segs instanceof Data_List_Types.Cons && (segs.value1 instanceof Data_List_Types.Cons && segs.value1.value1 instanceof Data_List_Types.Cons)) {
                                            return bind(lift(completeHori(v1.value0)(v1.value1.value0)(segs.value0)(segs.value1.value0)(segs.value1.value1.value0)))(function (v4) {
                                                return pure(new Data_List_Types.Cons(v4.segl, new Data_List_Types.Cons(v4.segr, segs.value1.value1.value1)));
                                            });
                                        };
                                        return lift(new Data_Either.Left("Operations after hori do not fit!"));
                                    });
                                });
                            };
                            return lift(new Data_Either.Left("Applying a single-transition operation while several transitions are left!"));
                        };
                        if (v1.value1 instanceof Data_List_Types.Nil) {
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMFreezeOnly) {
                                return bind(freeze(v)(v2.value0.value0)(v1.value0))(function (seg) {
                                    return pure(new Data_List_Types.Cons(seg, Data_List_Types.Nil.value));
                                });
                            };
                            if (v2.value0 instanceof ProtoVoices_Leftmost.LMSplitOnly) {
                                return bind(prepareSplit(v.id)(v1.value0)(v2.value0.value0))(function (v3) {
                                    return bind(go(v)(new Data_List_Types.Cons(v3.childlTop, new Data_List_Types.Cons(v3.childrTop, Data_List_Types.Nil.value)))(v2.value1))(function (segs) {
                                        if (segs instanceof Data_List_Types.Cons && (segs.value1 instanceof Data_List_Types.Cons && segs.value1.value1 instanceof Data_List_Types.Nil)) {
                                            return pure(new Data_List_Types.Cons(completeSplit(v1.value0)(segs.value0)(segs.value1.value0), Data_List_Types.Nil.value));
                                        };
                                        return lift(new Data_Either.Left("Operations after splitOnly do not fit!"));
                                    });
                                });
                            };
                            return lift(new Data_Either.Left("Applying a non-single operation to a single transition!"));
                        };
                        throw new Error("Failed pattern match at ProtoVoices.Folding (line 420, column 48 - line 458, column 84): " + [ v1.value1.constructor.name ]);
                    };
                    return lift(new Data_Either.Left("Lengths of top-level and derivation do not match!"));
                };
            };
        };
        return bind2(Control_Monad_State_Trans.runStateT(go(startSlice)(fromFoldable1(map1(prepareTop)(topSegments)))(fromFoldable1(deriv)))({
            maxS: 0,
            maxT: 0,
            x: 0.0,
            piece: [  ]
        }))(function (v) {
            return pure1({
                reduction: {
                    start: startSlice,
                    segments: v.value0,
                    nextSliceId: ProtoVoices_Model.incS(v.value1.maxS),
                    nextTransId: ProtoVoices_Model.incT(v.value1.maxT)
                },
                piece: Data_Maybe.fromMaybe([  ])(Data_Array.tail(v.value1.piece))
            });
        });
    };
};
var foldAgenda = function (v) {
    return function (v1) {
        return function (v2) {
            if (v2 instanceof Data_List_Types.Nil) {
                return pure2(Data_Unit.unit);
            };
            if (v2 instanceof Data_List_Types.Cons && v2.value1 instanceof Data_List_Types.Nil) {
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Freeze) {
                    return v.freezeOnly(v1)(v2.value0);
                };
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Split) {
                    return bind3(v.splitOnly(v1)(v2.value0)(v2.value0.seg.op.value0))(function (children) {
                        return foldAgenda(v)(v1)(children);
                    });
                };
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Hori) {
                    return pure2(Data_Unit.unit);
                };
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 59, column 3 - line 64, column 24): " + [ v2.value0.seg.op.constructor.name ]);
            };
            if (v2 instanceof Data_List_Types.Cons && v2.value1 instanceof Data_List_Types.Cons) {
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Freeze) {
                    return discard2(v.freezeLeft(v1)(v2.value0))(function () {
                        return foldAgenda(v)(v2.value0.seg.rslice)(v2.value1);
                    });
                };
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Split) {
                    return bind3(v.splitLeft(v1)(v2.value0)(v2.value0.seg.op.value0))(function (children) {
                        return foldAgenda(v)(v1)(append(children)(v2.value1));
                    });
                };
                if (v2.value0.seg.op instanceof ProtoVoices_Model.Hori) {
                    if (v2.value1.value0.seg.op instanceof ProtoVoices_Model.Split) {
                        return bind3(v.splitRight(v1)(v2.value0)(v2.value1.value0)(v2.value1.value0.seg.op.value0))(function (children) {
                            return foldAgenda(v)(v1)(append(new Data_List_Types.Cons(v2.value0, children))(v2.value1.value1));
                        });
                    };
                    return bind3(v.hori(v1)(v2.value0)(v2.value1.value0)(v2.value0.seg.op.value0))(function (children) {
                        return foldAgenda(v)(v1)(append(children)(v2.value1.value1));
                    });
                };
                throw new Error("Failed pattern match at ProtoVoices.Folding (line 69, column 3 - line 86, column 55): " + [ v2.value0.seg.op.constructor.name ]);
            };
            throw new Error("Failed pattern match at ProtoVoices.Folding (line 48, column 1 - line 53, column 21): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var walkGraph = function (alg) {
    return function (start) {
        return function (agenda) {
            return discard2(alg.init(start))(function () {
                return foldAgenda(alg)(start)(agenda);
            });
        };
    };
};
var reductionToLeftmost = function (v) {
    var lmAlg = (function () {
        var modifyEither = function ($483) {
            return modify_1(bindFlipped($483));
        };
        var mkFreeze = function (seg) {
            return function (time) {
                return {
                    ties: fromFoldable2(seg.trans.edges.regular),
                    prevTime: time
                };
            };
        };
        var getUnexplained = function (slice) {
            return map1(function (v1) {
                return v1.note;
            })(Data_Array.filter(function (v1) {
                return eq1(v1.expl)(ProtoVoices_Model.NoExpl.value);
            })(ProtoVoices_Model.getInnerNotes(slice)));
        };
        var mkHori = function (childl) {
            return function (childm) {
                return function (childr) {
                    var horiChild = function (wrapper) {
                        return function (v1) {
                            if (v1.expl instanceof ProtoVoices_Model.HoriExpl) {
                                return new Data_Maybe.Just(new Data_Tuple.Tuple(v1.expl.value0, wrapper(v1.note)));
                            };
                            return Data_Maybe.Nothing.value;
                        };
                    };
                    var children = Data_Array.catMaybes(append1(map1(horiChild(ProtoVoices_Leftmost.LeftChild.create))(ProtoVoices_Model.getInnerNotes(childl.rslice)))(map1(horiChild(ProtoVoices_Leftmost.RightChild.create))(ProtoVoices_Model.getInnerNotes(childm.rslice))));
                    return {
                        children: fromFoldableWith1(append2)(children),
                        midEdges: childm.trans.edges,
                        ids: {
                            left: childl.trans.id,
                            lslice: childl.rslice.id,
                            mid: childm.trans.id,
                            rslice: childm.rslice.id,
                            right: childr.trans.id
                        },
                        unexplained: {
                            left: getUnexplained(childl.rslice),
                            right: getUnexplained(childm.rslice)
                        }
                    };
                };
            };
        };
        var hori = function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return discard2(modifyEither(function (st) {
                            return new Data_Either.Right((function () {
                                var $349 = {};
                                for (var $350 in st) {
                                    if ({}.hasOwnProperty.call(st, $350)) {
                                        $349[$350] = st[$350];
                                    };
                                };
                                $349.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMHorizontalize(mkHori(v4.childl)(v4.childm)(v4.childr)), st.lm);
                                return $349;
                            })());
                        }))(function () {
                            return pure2(map3(nothingMore)(new Data_List_Types.Cons(v4.childl, new Data_List_Types.Cons(v4.childm, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v4.childr)(v3.seg.rslice), Data_List_Types.Nil.value)))));
                        });
                    };
                };
            };
        };
        var mkSplit = function (childl) {
            return function (childr) {
                var getElaboration = function (n) {
                    if (n.expl instanceof ProtoVoices_Model.DoubleExpl) {
                        var $357 = eq2(n.expl.value0.orn)(new Data_Maybe.Just(ProtoVoices_Model.PassingLeft.value)) || (eq2(n.expl.value0.orn)(new Data_Maybe.Just(ProtoVoices_Model.PassingRight.value)) || eq2(n.expl.value0.orn)(new Data_Maybe.Just(ProtoVoices_Model.PassingMid.value)));
                        if ($357) {
                            return new Data_Maybe.Just(new EN(new Data_Tuple.Tuple({
                                left: new ProtoVoices_Model.Inner(n.expl.value0.leftParent),
                                right: new ProtoVoices_Model.Inner(n.expl.value0.rightParent)
                            }, [ {
                                child: n.note,
                                orn: n.expl.value0.orn
                            } ])));
                        };
                        return new Data_Maybe.Just(new ET(new Data_Tuple.Tuple({
                            left: new ProtoVoices_Model.Inner(n.expl.value0.leftParent),
                            right: new ProtoVoices_Model.Inner(n.expl.value0.rightParent)
                        }, [ {
                            child: n.note,
                            orn: new Data_Either.Right(n.expl.value0.orn)
                        } ])));
                    };
                    if (n.expl instanceof ProtoVoices_Model.RightExpl) {
                        return new Data_Maybe.Just(new ER(new Data_Tuple.Tuple(n.expl.value0.leftParent, [ {
                            child: n.note,
                            orn: n.expl.value0.orn
                        } ])));
                    };
                    if (n.expl instanceof ProtoVoices_Model.LeftExpl) {
                        return new Data_Maybe.Just(new EL(new Data_Tuple.Tuple(n.expl.value0.rightParent, [ {
                            child: n.note,
                            orn: n.expl.value0.orn
                        } ])));
                    };
                    if (n.expl instanceof ProtoVoices_Model.RootExpl) {
                        return new Data_Maybe.Just(new ET(new Data_Tuple.Tuple({
                            left: ProtoVoices_Model.Start.value,
                            right: ProtoVoices_Model.Stop.value
                        }, [ {
                            child: n.note,
                            orn: new Data_Either.Left(ProtoVoices_Leftmost.RootNote.value)
                        } ])));
                    };
                    return Data_Maybe.Nothing.value;
                };
                var v1 = partitionElaborations1(Data_Array.catMaybes(map1(getElaboration)(ProtoVoices_Model.getInnerNotes(childl.rslice))));
                var prs = bind4(fromFoldable3(v1.n))(function (v2) {
                    return bind4(v2.value1)(function (child) {
                        return discard3(guard(eq2(child.orn)(new Data_Maybe.Just(ProtoVoices_Model.PassingLeft.value))))(function () {
                            return pure3({
                                left: new ProtoVoices_Model.Inner(child.child),
                                right: v2.value0.right
                            });
                        });
                    });
                });
                var pls = bind4(fromFoldable3(v1.n))(function (v2) {
                    return bind4(v2.value1)(function (child) {
                        return discard3(guard(eq2(child.orn)(new Data_Maybe.Just(ProtoVoices_Model.PassingRight.value))))(function () {
                            return pure3({
                                left: v2.value0.left,
                                right: new ProtoVoices_Model.Inner(child.child)
                            });
                        });
                    });
                });
                return {
                    regular: fromFoldableWith2(append1)(v1.t),
                    passing: fromFoldableWith2(append1)(v1.n),
                    fromLeft: fromFoldableWith3(append1)(v1.r),
                    fromRight: fromFoldableWith3(append1)(v1.l),
                    unexplained: getUnexplained(childl.rslice),
                    keepLeft: fromFoldable2(childl.trans.edges.regular),
                    keepRight: fromFoldable2(childr.trans.edges.regular),
                    passLeft: difference(childl.trans.edges.passing)(pls),
                    passRight: difference(childr.trans.edges.passing)(prs),
                    ids: {
                        left: childl.trans.id,
                        slice: childl.rslice.id,
                        right: childr.trans.id
                    }
                };
            };
        };
        var splitLeft = function (v1) {
            return function (v2) {
                return function (v3) {
                    return discard2(modifyEither(function (st) {
                        return new Data_Either.Right((function () {
                            var $382 = {};
                            for (var $383 in st) {
                                if ({}.hasOwnProperty.call(st, $383)) {
                                    $382[$383] = st[$383];
                                };
                            };
                            $382.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMSplitLeft(mkSplit(v3.childl)(v3.childr)), st.lm);
                            return $382;
                        })());
                    }))(function () {
                        return pure2(map3(nothingMore)(new Data_List_Types.Cons(v3.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v3.childr)(v2.seg.rslice), Data_List_Types.Nil.value))));
                    });
                };
            };
        };
        var splitOnly = function (v1) {
            return function (v2) {
                return function (v3) {
                    return discard2(modifyEither(function (st) {
                        return new Data_Either.Right((function () {
                            var $391 = {};
                            for (var $392 in st) {
                                if ({}.hasOwnProperty.call(st, $392)) {
                                    $391[$392] = st[$392];
                                };
                            };
                            $391.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMSplitOnly(mkSplit(v3.childl)(v3.childr)), st.lm);
                            return $391;
                        })());
                    }))(function () {
                        return pure2(map3(nothingMore)(new Data_List_Types.Cons(v3.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v3.childr)(v2.seg.rslice), Data_List_Types.Nil.value))));
                    });
                };
            };
        };
        var splitRight = function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return discard2(modifyEither(function (st) {
                            return new Data_Either.Right((function () {
                                var $401 = {};
                                for (var $402 in st) {
                                    if ({}.hasOwnProperty.call(st, $402)) {
                                        $401[$402] = st[$402];
                                    };
                                };
                                $401.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMSplitRight(mkSplit(v4.childl)(v4.childr)), st.lm);
                                return $401;
                            })());
                        }))(function () {
                            return pure2(map3(nothingMore)(new Data_List_Types.Cons(v4.childl, new Data_List_Types.Cons(ProtoVoices_Model.attachSegment(v4.childr)(v3.seg.rslice), Data_List_Types.Nil.value))));
                        });
                    };
                };
            };
        };
        var freezeOnly = function (_lSlice) {
            return function (v1) {
                return modifyEither(function (st) {
                    if (st.piece instanceof Data_List_Types.Nil) {
                        return new Data_Either.Left("Piece and reduction do not fit together: piece is too short!");
                    };
                    if (st.piece instanceof Data_List_Types.Cons) {
                        return new Data_Either.Right((function () {
                            var $410 = {};
                            for (var $411 in st) {
                                if ({}.hasOwnProperty.call(st, $411)) {
                                    $410[$411] = st[$411];
                                };
                            };
                            $410.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMFreezeOnly(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                            $410.piece = st.piece.value1;
                            return $410;
                        })());
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 348, column 27 - line 350, column 123): " + [ st.piece.constructor.name ]);
                });
            };
        };
        var freezeLeft = function (_lSlice) {
            return function (v1) {
                return modifyEither(function (st) {
                    if (st.piece instanceof Data_List_Types.Nil) {
                        return new Data_Either.Left("Piece and reduction do not fit together: piece is too short!");
                    };
                    if (st.piece instanceof Data_List_Types.Cons) {
                        return new Data_Either.Right((function () {
                            var $419 = {};
                            for (var $420 in st) {
                                if ({}.hasOwnProperty.call(st, $420)) {
                                    $419[$420] = st[$420];
                                };
                            };
                            $419.lm = new Data_List_Types.Cons(new ProtoVoices_Leftmost.LMFreezeLeft(mkFreeze(v1.seg)(st.piece.value0.time)), st.lm);
                            $419.piece = st.piece.value1;
                            return $419;
                        })());
                    };
                    throw new Error("Failed pattern match at ProtoVoices.Folding (line 353, column 27 - line 355, column 123): " + [ st.piece.constructor.name ]);
                });
            };
        };
        return {
            init: function (v1) {
                return pure2(Data_Unit.unit);
            },
            freezeOnly: freezeOnly,
            freezeLeft: freezeLeft,
            splitOnly: splitOnly,
            splitLeft: splitLeft,
            splitRight: splitRight,
            hori: hori
        };
    })();
    var agenda = map3(nothingMore)(v.reduction.segments);
    return bind2(Data_Function.flip(Control_Monad_State.execState)(new Data_Either.Right({
        lm: Data_List_Types.Nil.value,
        piece: new Data_List_Types.Cons({
            time: new Data_Either.Left(""),
            notes: [  ]
        }, fromFoldable1(v.piece))
    }))(walkGraph(lmAlg)(v.reduction.start)(agenda)))(function (st$prime) {
        return pure1(Data_Array.reverse(fromFoldable3(st$prime.lm)));
    });
};
var emptyGraph = /* #__PURE__ */ (function () {
    return {
        slices: Data_Map_Internal.empty,
        transitions: Data_Map_Internal.empty,
        horis: Data_List_Types.Nil.value,
        maxd: 0.0,
        maxx: 0.0,
        currentDepth: 0.0
    };
})();
var addUnusedEdgesRight = function (lslice) {
    return function (segr) {
        var edges$prime = append3(segr.trans.edges)(fold(map1(ProtoVoices_Model.explRightEdge)(ProtoVoices_Model.getInnerNotes(lslice))));
        return {
            rslice: segr.rslice,
            op: segr.op,
            trans: {
                id: segr.trans.id,
                is2nd: segr.trans.is2nd,
                edges: edges$prime
            }
        };
    };
};
var addUnusedEdgesLeft = function (segl) {
    var edges$prime = append3(segl.trans.edges)(fold(map1(ProtoVoices_Model.explLeftEdge)(ProtoVoices_Model.getInnerNotes(segl.rslice))));
    return {
        rslice: segl.rslice,
        op: segl.op,
        trans: {
            id: segl.trans.id,
            is2nd: segl.trans.is2nd,
            edges: edges$prime
        }
    };
};
var findSurface = function (showAllEdges) {
    return function (red) {
        var split = function (ag) {
            return function (v) {
                var segLeft = (function () {
                    if (showAllEdges) {
                        return addUnusedEdgesLeft(v.childl);
                    };
                    return v.childl;
                })();
                var childr$prime = ProtoVoices_Model.attachSegment(v.childr)(ag.seg.rslice);
                var segRight = (function () {
                    if (showAllEdges) {
                        return addUnusedEdgesRight(v.childl.rslice)(childr$prime);
                    };
                    return childr$prime;
                })();
                return pure2(map3(nothingMore)(new Data_List_Types.Cons(segLeft, new Data_List_Types.Cons(segRight, Data_List_Types.Nil.value))));
            };
        };
        var hori = function (v) {
            return function (ag1) {
                return function (ag2) {
                    return function (v1) {
                        var childr$prime = (function () {
                            var v2 = ProtoVoices_Model.attachSegment(v1.childr)(ag2.seg.rslice);
                            return {
                                op: v2.op,
                                rslice: v2.rslice,
                                trans: {
                                    id: v2.trans.id,
                                    is2nd: v2.trans.is2nd,
                                    edges: ProtoVoices_Model.horiEdgesRight(v1.childm.rslice)(ag2.seg.trans.edges)
                                }
                            };
                        })();
                        var childl$prime = {
                            rslice: v1.childl.rslice,
                            op: v1.childl.op,
                            trans: {
                                id: v1.childl.trans.id,
                                is2nd: v1.childl.trans.is2nd,
                                edges: ProtoVoices_Model.horiEdgesLeft(ag1.seg.trans.edges)(v1.childl.rslice)
                            }
                        };
                        return pure2(map3(nothingMore)(new Data_List_Types.Cons(childl$prime, new Data_List_Types.Cons(v1.childm, new Data_List_Types.Cons(childr$prime, Data_List_Types.Nil.value)))));
                    };
                };
            };
        };
        var freeze = function (_lslice) {
            return function (ag) {
                return modify_1(function (st) {
                    return {
                        slices: Data_Array.snoc(st.slices)(ag.seg.rslice),
                        transs: Data_Array.snoc(st.transs)(ag.seg.trans)
                    };
                });
            };
        };
        var surfaceAlg = {
            init: function (s) {
                return modify_1(function (st) {
                    var $440 = {};
                    for (var $441 in st) {
                        if ({}.hasOwnProperty.call(st, $441)) {
                            $440[$441] = st[$441];
                        };
                    };
                    $440.slices = Data_Array.snoc(st.slices)(s);
                    return $440;
                });
            },
            freezeLeft: freeze,
            freezeOnly: freeze,
            splitLeft: function (v) {
                return split;
            },
            splitOnly: function (v) {
                return split;
            },
            splitRight: function (v) {
                return function (v1) {
                    return split;
                };
            },
            hori: hori
        };
        var agenda = map3(nothingMore)(red.segments);
        return Data_Function.flip(Control_Monad_State.execState)({
            slices: [  ],
            transs: [  ]
        })(walkGraph(surfaceAlg)(red.start)(agenda));
    };
};
var addHoriEdge = function (v) {
    return function (v1) {
        return modify_1(function (st) {
            var $445 = {};
            for (var $446 in st) {
                if ({}.hasOwnProperty.call(st, $446)) {
                    $445[$446] = st[$446];
                };
            };
            $445.horis = new Data_List_Types.Cons({
                child: v.id,
                parent: v1.id
            }, st.horis);
            return $445;
        });
    };
};
var addGraphTrans = function (il) {
    return function (v) {
        return function (ir) {
            return modify_1(function (st) {
                var $453 = {};
                for (var $454 in st) {
                    if ({}.hasOwnProperty.call(st, $454)) {
                        $453[$454] = st[$454];
                    };
                };
                $453.transitions = insert(v.id)({
                    left: il,
                    right: ir,
                    id: v.id,
                    edges: v.edges
                })(st.transitions);
                return $453;
            });
        };
    };
};
var addGraphSlice = function (slice) {
    return function (depth) {
        var gslice = {
            depth: depth,
            slice: slice
        };
        var add1 = function (st) {
            var $458 = {};
            for (var $459 in st) {
                if ({}.hasOwnProperty.call(st, $459)) {
                    $458[$459] = st[$459];
                };
            };
            $458.maxd = max2(depth)(st.maxd);
            $458.maxx = max2(slice.x)(st.maxx);
            $458.slices = insert1(slice.id)(gslice)(st.slices);
            return $458;
        };
        return modify_1(add1);
    };
};
var graphAlg = function (flatHori) {
    return function (showAllEdges) {
        var split = function (lSlice) {
            return function (lDepth) {
                return function (item) {
                    return function (v) {
                        return discard2(addGraphTrans(lSlice.id)(item.seg.trans)(item.seg.rslice.id))(function () {
                            var childr$prime = ProtoVoices_Model.attachSegment(v.childr)(item.seg.rslice);
                            return pure2(new Data_List_Types.Cons({
                                seg: (function () {
                                    if (showAllEdges) {
                                        return addUnusedEdgesLeft(v.childl);
                                    };
                                    return v.childl;
                                })(),
                                more: {
                                    rdepth: max2(lDepth)(item.more.rdepth) + 1.0
                                }
                            }, new Data_List_Types.Cons({
                                seg: (function () {
                                    if (showAllEdges) {
                                        return addUnusedEdgesRight(v.childl.rslice)(childr$prime);
                                    };
                                    return childr$prime;
                                })(),
                                more: {
                                    rdepth: item.more.rdepth
                                }
                            }, Data_List_Types.Nil.value)));
                        });
                    };
                };
            };
        };
        var splitRight = function (v) {
            return function (left) {
                return function (right) {
                    return function (splitop) {
                        return split(left.seg.rslice)(left.more.rdepth)(right)(splitop);
                    };
                };
            };
        };
        var splitTrans = function (lSlice) {
            return function (item) {
                return function (splitop) {
                    return bind3(gets(function (v) {
                        return v.currentDepth;
                    }))(function (lDepth) {
                        return split(lSlice)(lDepth)(item)(splitop);
                    });
                };
            };
        };
        var init = function (start) {
            return addGraphSlice(start)(0.0);
        };
        var hori = function (lSlice) {
            return function (left) {
                return function (right) {
                    return function (v) {
                        return bind3(gets(function (v1) {
                            return v1.currentDepth;
                        }))(function (currentDepth) {
                            return discard2(addGraphTrans(lSlice.id)(left.seg.trans)(left.seg.rslice.id))(function () {
                                return discard2(addGraphSlice(left.seg.rslice)(left.more.rdepth))(function () {
                                    return discard2(addHoriEdge(v.childl.rslice)(left.seg.rslice))(function () {
                                        return discard2(addHoriEdge(v.childm.rslice)(left.seg.rslice))(function () {
                                            return discard2(addGraphTrans(left.seg.rslice.id)(right.seg.trans)(right.seg.rslice.id))(function () {
                                                var dsub = (function () {
                                                    if (flatHori) {
                                                        return left.more.rdepth + 1.0;
                                                    };
                                                    return max2(currentDepth)(max2(left.more.rdepth)(right.more.rdepth)) + 1.0;
                                                })();
                                                var childr$prime = ProtoVoices_Model.attachSegment(v.childr)(right.seg.rslice);
                                                return pure2(new Data_List_Types.Cons({
                                                    seg: (function () {
                                                        if (showAllEdges) {
                                                            return {
                                                                rslice: v.childl.rslice,
                                                                op: v.childl.op,
                                                                trans: {
                                                                    id: v.childl.trans.id,
                                                                    is2nd: v.childl.trans.is2nd,
                                                                    edges: ProtoVoices_Model.horiEdgesLeft(left.seg.trans.edges)(v.childl.rslice)
                                                                }
                                                            };
                                                        };
                                                        return v.childl;
                                                    })(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new Data_List_Types.Cons({
                                                    seg: (function () {
                                                        if (showAllEdges) {
                                                            return {
                                                                rslice: v.childm.rslice,
                                                                op: v.childm.op,
                                                                trans: {
                                                                    id: v.childm.trans.id,
                                                                    is2nd: v.childm.trans.is2nd,
                                                                    edges: ProtoVoices_Model.horiEdgesMid(v.childl.rslice)(v.childm.trans.edges)(v.childm.rslice)
                                                                }
                                                            };
                                                        };
                                                        return v.childm;
                                                    })(),
                                                    more: {
                                                        rdepth: dsub
                                                    }
                                                }, new Data_List_Types.Cons({
                                                    seg: (function () {
                                                        if (showAllEdges) {
                                                            return {
                                                                op: childr$prime.op,
                                                                rslice: childr$prime.rslice,
                                                                trans: {
                                                                    id: childr$prime.trans.id,
                                                                    is2nd: childr$prime.trans.is2nd,
                                                                    edges: ProtoVoices_Model.horiEdgesRight(v.childm.rslice)(right.seg.trans.edges)
                                                                }
                                                            };
                                                        };
                                                        return childr$prime;
                                                    })(),
                                                    more: {
                                                        rdepth: right.more.rdepth
                                                    }
                                                }, Data_List_Types.Nil.value))));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    };
                };
            };
        };
        var freezeTrans = function (lSlice) {
            return function (item) {
                return discard2(addGraphTrans(lSlice.id)(item.seg.trans)(item.seg.rslice.id))(function () {
                    return discard2(addGraphSlice(item.seg.rslice)(item.more.rdepth))(function () {
                        return modify_1(function (st) {
                            var $480 = {};
                            for (var $481 in st) {
                                if ({}.hasOwnProperty.call(st, $481)) {
                                    $480[$481] = st[$481];
                                };
                            };
                            $480.currentDepth = item.more.rdepth;
                            return $480;
                        });
                    });
                });
            };
        };
        return {
            init: init,
            freezeOnly: freezeTrans,
            freezeLeft: freezeTrans,
            splitOnly: splitTrans,
            splitLeft: splitTrans,
            splitRight: splitRight,
            hori: hori
        };
    };
};
var evalGraph = function (flatHori) {
    return function (showAllEdges) {
        return function (reduction) {
            var agenda = map3(function (seg) {
                return {
                    seg: seg,
                    more: {
                        rdepth: 0.0
                    }
                };
            })(reduction.segments);
            return Data_Function.flip(Control_Monad_State.execState)(emptyGraph)(walkGraph(graphAlg(flatHori)(showAllEdges))(reduction.start)(agenda));
        };
    };
};
export {
    nothingMore,
    foldAgenda,
    walkGraph,
    addGraphSlice,
    addGraphTrans,
    addHoriEdge,
    addUnusedEdgesLeft,
    addUnusedEdgesRight,
    graphAlg,
    evalGraph,
    emptyGraph,
    ET,
    EN,
    ER,
    EL,
    partitionElaborations,
    reductionToLeftmost,
    leftmostToReduction,
    findSurface
};
